import { Component, Input, NgZone, OnInit } from '@angular/core';
import { MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { db_tables } from '@app/consts';
import { UntypedFormGroup } from '@angular/forms';
import { FormElement } from '@app/modules/form-generator/edit-form-v3/models/form.model';
import { SelectWorkLocationDialogComponent } from './components/select-work-location-dialog/select-work-location-dialog.component';
import { WorkLocation } from '@app/modules/work-locations/models/work-location.model';
import moment from 'moment';

@Component({
  selector: 'app-work-location-form-field',
  templateUrl: './work-location-form-field.component.html',
  styleUrls: ['./work-location-form-field.component.scss']
})
export class WorkLocationFormFieldComponent implements OnInit {
  @Input() formElement: FormElement;
  @Input() parentGroup: UntypedFormGroup;
  @Input() readOnly: boolean;

  public db_tables = db_tables;
  isLoading: boolean;
  items: WorkLocation[] = []
  clearSelectedItems: boolean = false;
  searchValue: string;
  searchFilterString: string;
  getUsersRequest: any;
  selectItemsDialogRef: MatDialogRef<SelectWorkLocationDialogComponent>;

  constructor(
    private dialog: MatDialog,
    private ngZone: NgZone,
    public translate: TranslateService,
  ) { }

  ngOnInit(): void {
    if (this.parentGroup.controls[this.formElement.formControl].value !== null && this.parentGroup.controls[this.formElement.formControl].value !== undefined) {
      this.items = this.parentGroup.controls[this.formElement.formControl].value;
      this.items = this.items.filter(item => item !== null && item !== undefined);
    }
  }

  showAddModal() {
    const dialogConfig = new MatDialogConfig();

    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;

    dialogConfig.data = {
      nonSelectableItems: [...this.items],
      selectableMode: this.formElement.selectableMode || 'single',
    };

    this.ngZone.runOutsideAngular(() => {
      this.selectItemsDialogRef = this.dialog.open(SelectWorkLocationDialogComponent, dialogConfig);
    });

    const sub = this.selectItemsDialogRef.componentInstance.emitSelectedWorkLocations.subscribe((event) => {
      this.addItems(event)
    });
  }

  addItems(selectedItems: any) {
    this.items = [...selectedItems]

    this.setFormValue()

    this.selectItemsDialogRef.close();
  }

  deleteAllSelected(itemsToDelete: WorkLocation[]) {
    this.items = this.items.filter(data => !itemsToDelete.includes(data))
    this.setFormValue();
    this.clearSelectedItems = !this.clearSelectedItems;
  }

  setFormValue() {
    this.parentGroup.controls[this.formElement.formControl].setValue(this.items)
  }

  isWorkLocationInactive(workLocation: WorkLocation): Boolean {
    if (!workLocation?.endDate) {
      return false;
    }
    const date = moment(workLocation?.endDate);
    const now = moment(); // Current date and time

    if (date.isBefore(now)) {
      return true;
    }
    else {
      return false;
    }
  }

  isFieldDisabled(): boolean {
    return this.formElement?.disabled === 'true' || this.readOnly;
  }

  getDisabledReadOnlyAnnouncement(): string {
    if (!this.isFieldDisabled()) {
      return '';
    }
    if (this.readOnly) {
      return this.translate.instant('Read-only', { Default: 'Read-only' });
    }
    if (this.formElement?.disabled === 'true') {
      return this.translate.instant('Disabled', { Default: 'Disabled' });
    }
    return '';
  }

}

